module.exports = __webpack_public_path__ + "static/img/auto_verkaufen_online.7ef4c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base/auto_verkaufen_online.png
// module id = xuFy
// module chunks = 1